export default "__VITE_ASSET__BldR7hbU__"